import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { message } from 'antd';
import {
  profileView,
  profileActions,
  profileDownloads,
  respondRequestAction,
  blockingProfile
} from './api';

const initialState = {
  loading: false,
  profile_list: [],
  profileLoading: [],
  sendrequestLoading: [],
  shortlistLoading: [],
  downloadProfile: [],
  downloadLoading: false,
  respondActionsLoading: false,
  blockProfileLoading: false
};

const actions = {
  GET_BY_PROFILEVIEW: 'get_by_profileView/GET_BY_PROFILEVIEW',
  SEND_REQUEST_LIST: 'send_request_list/SEND_REQUEST_LIST',
  SHORT_LIST: 'short_list/SHORT_LIST',
  DOWNLOAD_PROFILEBYID: 'download_profilebyid/DOWNLOAD_PROFILEBYID',
  RESPOND_ACTIONS: 'respondActions/RESPOND_ACTIONS',
  BLOCK_PROFILE: 'blockProfile/BLOCK_PROFILE'
};

export const get_by_profileView = createAsyncThunk(
  actions.GET_BY_PROFILEVIEW,
  async (payload) => {
    const response = await profileView(payload);
    return response;
  }
);

// send_request_list/SEND_REQUEST_LIST
export const send_request_list = createAsyncThunk(
  actions.SEND_REQUEST_LIST,
  async (payload) => {
    const response = await profileActions('send-request', payload);
    return response;
  }
);

// short_list/SHORT_LIST
export const short_list = createAsyncThunk(
  actions.SHORT_LIST,
  async (payload) => {
    const response = await profileActions('shortlist', payload);
    return response;
  }
);

// download_profilebyid/DOWNLOAD_PROFILEBYID
export const download_profilebyid = createAsyncThunk(
  actions.DOWNLOAD_PROFILEBYID,
  async (payload) => {
    const response = await profileDownloads(
      `download-profile/${payload}`,
      payload
    );
    return response;
  }
);

// respondActions/RESPOND_ACTIONS
export const respondActions = createAsyncThunk(
  actions.RESPOND_ACTIONS,
  async (payload) => {
    const response = await respondRequestAction('respond-to-request', payload);
    return response;
  }
);

// blockProfile/BLOCK_PROFILE
export const blockProfile = createAsyncThunk(
  actions.BLOCK_PROFILE,
  async (payload) => {
    const response = await blockingProfile('block-profile', payload);
    return response;
  }
);

export const profileViewDetails = createSlice({
  name: 'profileView',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(get_by_profileView.pending, (state) => {
        state.profileLoading = true;
      })
      .addCase(get_by_profileView.fulfilled, (state, action) => {
        const { data } = action.payload;
        // console.log('slice_View', data.Profiles);
        // state.allOnBoardingList = data.items ? data.items : [];
        // state.pagination = data.meta || null;
        state.profile_list = data;
        state.profileLoading = false;

        // console.log('slicelog', data);
      })
      .addCase(get_by_profileView.rejected, (state, action) => {
        const { message: msg } = action.error;
        state.profileLoading = false;
        message.error(msg);
      });
    // send_request_list
    builder
      .addCase(send_request_list.pending, (state) => {
        state.sendrequestLoading = true;
      })
      .addCase(send_request_list.fulfilled, (state, action) => {
        const { success, message: msg } = action.payload;
        // console.log('slice_View', data.Profiles);
        // state.allOnBoardingList = data.items ? data.items : [];
        // state.pagination = data.meta || null;
        // state.profile_list = data;
        state.sendrequestLoading = false;

        console.log('slice_payload', success);

        if (!success) {
          message.error(msg);
        } else {
          message.success(msg);
        }
        // console.log('slicelog', data);
      })
      .addCase(send_request_list.rejected, (state, action) => {
        const { message: msg } = action.error;
        state.sendrequestLoading = false;
        message.error(msg);
      });

    // short_list
    builder
      .addCase(short_list.pending, (state) => {
        state.shortlistLoading = true;
      })
      .addCase(short_list.fulfilled, (state, action) => {
        const { success, message: msg } = action.payload;
        // console.log('slice_View', data.Profiles);
        // state.allOnBoardingList = data.items ? data.items : [];
        // state.pagination = data.meta || null;
        // state.profile_list = data;
        state.shortlistLoading = false;
        if (!success) {
          message.error(msg);
        } else {
          message.success(msg);
        }

        // console.log('slicelog', data);
      })
      .addCase(short_list.rejected, (state, action) => {
        const { message: msg } = action.error;
        state.shortlistLoading = false;
        message.error(msg);
      });

    // download_profilebyid
    builder
      .addCase(download_profilebyid.pending, (state) => {
        state.downloadLoading = true;
      })
      .addCase(download_profilebyid.fulfilled, (state, action) => {
        const { data } = action.payload;
        // , success, message: msg
        state.downloadLoading = false;
        state.downloadProfile = data;
        // if (!success) {
        //   message.error(msg);
        // } else {
        //   message.success(msg);
        // }

        // console.log('slicelog', data);
      })
      .addCase(download_profilebyid.rejected, (state, action) => {
        const { message: msg } = action.error;
        state.downloadLoading = false;
        message.error(msg);
      });

    // respondActions
    builder
      .addCase(respondActions.pending, (state) => {
        state.respondActionsLoading = true;
      })
      .addCase(respondActions.fulfilled, (state, action) => {
        const { success, message: msg } = action.payload;
        // console.log('slice_View', data.Profiles);
        // state.allOnBoardingList = data.items ? data.items : [];
        // state.pagination = data.meta || null;
        // state.profile_list = data;
        state.respondActionsLoading = false;
        if (!success) {
          message.error(msg);
        } else {
          message.success(msg);
        }

        // console.log('slicelog', data);
      })
      .addCase(respondActions.rejected, (state, action) => {
        const { message: msg } = action.error;
        state.respondActionsLoading = false;
        message.error(msg);
      });

    // blockProfile
    builder
      .addCase(blockProfile.pending, (state) => {
        state.blockProfileLoading = true;
      })
      .addCase(blockProfile.fulfilled, (state, action) => {
        const { success, message: msg } = action.payload;
        state.blockProfileLoading = false;
        if (!success) {
          message.error(msg);
        } else {
          message.success(msg);
        }
      })
      .addCase(blockProfile.rejected, (state, action) => {
        const { message: msg } = action.error;
        state.blockProfileLoading = false;
        message.error(msg);
      });
  }
});

export default profileViewDetails.reducer;
